import React from 'react';
import './Background.scss';

const Background = (): JSX.Element => (
  <div className="background-page" />
);

export default Background;
